import { sqItemsApi } from '@seeqdev/api/endpoint/ItemsApi';
import { SeeqNames } from '@seeqdev/constants';

export const updateTableDefinitionName = async ({
  tableDefinitionId,
  name,
}: {
  tableDefinitionId: string;
  name: string;
}) => await sqItemsApi.setProperty({ value: name }, { id: tableDefinitionId, propertyName: SeeqNames.Properties.Name });
